import { useNavigate } from "react-router-dom";
import TestFormInterface from "../../../Interfaces/TestFormInterface";
import StyledButton from "../../UI/StyledButton";
import StyledInput from "../../UI/StyledInput";
import ReactLoading from "react-loading";
import { useEffect, useState } from "react";
import TestApi from "../../../Api/TestApi";
import StyledMultiSelect from "../../UI/StyledMultiSelect";
import StyledSelect from "../../UI/StyledSelect";
import { directus } from "../../../Api/FetchDirectus";
import { readItems } from "@directus/sdk";
import CourseBlockInterface from "../../../Interfaces/CourseBlockInterface";

const TestForm = ({ close }: TestFormInterface) => {
  const navigate = useNavigate();
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [activity, setActivity] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [ageStatus, setAgeStatus] = useState(false);
  const [genderStatus, setGenderStatus] = useState(false);
  const [activityStatus, setActivityStatus] = useState(false);
  const [jobTitleStatus, setJobTitleStatus] = useState(false);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState(false);
  const [courseList, setCourseList] = useState<
    Array<CourseBlockInterface> | Record<string, any>[]
  >([]);
  const [complianceList, setComplianceList] = useState<
    { course_name: string; test_name: string }[] | Record<string, any>[]
  >([]);

  const optionList = [
    {
      name: "Педагогика и психология физического воспитания и спорта",
      id: "6",
    },
    { name: "Спортивная медицина", id: "3" },
    { name: "Физиология и биохимия мышечной деятельности", id: "7" },
    { name: "Теория и методика физической культуры и спорта", id: "5" },
    { name: "Биомеханика и прикладная кинезиология", id: "4" },
    {
      name: "Менеджмент и экономика в сфере физической культуры и спорта",
      id: "2",
    },
  ];

  const fetchCourse = async () => {
    try {
      return await directus.request(readItems(`Course`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchCompliance = async () => {
    try {
      return await directus.request(readItems(`compliance`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchCourseList() {
    setCourseList([...(await fetchCourse())]);
  }

  async function fetchComplianceList() {
    setComplianceList([...(await fetchCompliance())]);
  }

  function onClose() {
    close(false);
  }

  function onChange(e: any, type: string) {
    if (type === "age") {
      setAge(e);
    }

    if (type === "gender") {
      setGender(e);
    }

    if (type === "activity") {
      setActivity(e.target.value);
    }

    if (type === "jobTitle") {
      setJobTitle(e.target.value);
    }
  }

  async function goTest() {
    let count = 0;

    selectedOptions.map(
      (item: { id: string; course_name: string; chosen: boolean }) => {
        if (item.chosen) {
          count++;
        }
        return count;
      }
    );

    if (age.trim() === "" || Number(age) < 16 || Number(age) > 70) {
      setAgeStatus(true);
    }

    if (gender.trim() === "") {
      setGenderStatus(true);
    }

    if (activity.trim() === "") {
      setActivityStatus(true);
    }

    if (jobTitle.trim() === "") {
      setJobTitleStatus(true);
    }

    if (count < 3) {
      setSelectedOptionsStatus(true);
    }

    if (
      age !== "" &&
      Number(age) >= 16 &&
      Number(age) <= 70 &&
      gender !== "" &&
      activity !== "" &&
      jobTitle !== "" &&
      count >= 3
    ) {
      let selectedCompetencies = selectedOptions.filter(
        (item: { id: string; course_name: string; chosen: boolean }) =>
          item.chosen === true
      );

      let competenciesList = selectedCompetencies.map(
        (item: { id: string; course_name: string; chosen: boolean }) =>
          item.course_name
      );

      let chosenIds: string[] = [];

      competenciesList.map((item) => {
        courseList.map((course) => {
          if (course.title === item) {
            chosenIds.push(course.test_enter_id.toString());
          }
        });
      });


      const data = {
        sphere: activity,
        position: jobTitle,
        competencies: chosenIds,
      };


      setLoader(true);
      const startTest = await TestApi.startTest(data);

      if (startTest.status === 200) {
        localStorage.setItem("question", JSON.stringify(startTest.data));
        localStorage.setItem("session_code", startTest.sessionCode);
        localStorage.setItem(
          "total_question",
          JSON.stringify(startTest.totalQuestions)
        );
        localStorage.setItem("age", age);
        localStorage.setItem("gender", gender);
        localStorage.setItem("activity", activity);
        localStorage.setItem("position", jobTitle);
        localStorage.setItem(
          "competencies_list",
          JSON.stringify(chosenIds)
        );

        localStorage.removeItem("test_count");
        localStorage.removeItem("radar_data");

        window.scrollTo(0, 0);
        navigate("/intro_test");
      }

      setLoader(false);
    }
  }

  useEffect(() => {
    fetchCourseList();
    fetchComplianceList();
  }, []);

  return (
    <div className="popUp">
      <div className="popTestForm">
        <div className="closeFormBox">
          <div className="closeFormButton" onClick={onClose}>
            <span></span>
            <span></span>
          </div>
        </div>
        {ageStatus ? (
          <div className="errorText">
            {age && (Number(age) < 16 || Number(age) > 70)
              ? "Возраст должен быть от 16 до 70"
              : "Укажите возраст"}
          </div>
        ) : null}
        <StyledInput
          type="number"
          text="Возраст"
          placeholder="Укажите возраст"
          className={ageStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "age")}
        />
        {genderStatus ? <div className="errorText">Укажите пол</div> : null}
        <StyledSelect
          text="Укажите пол"
          optionList={["Мужской", "Женский"]}
          placeholder="Укажите пол"
          className={genderStatus ? "testFormSelect error" : "testFormSelect"}
          onChange={(e: any) => onChange(e, "gender")}
        />
        {activityStatus ? (
          <div className="errorText">Заполните сферу деятельности</div>
        ) : null}{" "}
        <StyledInput
          text="Сфера деятельности"
          placeholder="Укажите сферу деятельности"
          className={activityStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "activity")}
        />
        {jobTitleStatus ? (
          <div className="errorText">Заполните должность</div>
        ) : null}
        <StyledInput
          text="Должность"
          placeholder="Укажите должность"
          className={jobTitleStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "jobTitle")}
        />
        {selectedOptionsStatus ? (
          <div className="errorText">Укажите минимум 3 компетенции</div>
        ) : null}
        <StyledMultiSelect
          text="Выбор интересующих компетенций для прохождения курса"
          optionList={complianceList}
          placeholder="Укажите минимум 3 компетенции"
          className={
            selectedOptionsStatus ? "testFormSelect error" : "testFormSelect"
          }
          list={(e: any) => setSelectedOptions(e)}
        />
        <div className="testFormStartBox">
          {" "}
          {loader ? (
            <ReactLoading
              type="spinningBubbles"
              color="black"
              height={"50px"}
              width={"50px"}
            />
          ) : (
            <StyledButton
              onClick={() => goTest()}
              className="blueButton testFormButton"
              text="НАЧАТЬ ТЕСТИРОВАНИЕ"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TestForm;
